/**
 * Class SIGNATURE ABILITIES — one active per hero, fired with Q (or the on-screen
 * button). This is what makes a rogue play like a rogue: heroes now differ by a
 * verb, not just a starting kit. Metadata only; the actual effect lives in
 * Game._useAbility() (it needs combat/effects/level), keeping this file data-only.
 *
 * Fields: name, glyph (UI icon), cd (cooldown seconds), mana (cost; 0 = martial),
 * desc (tooltip / recap line).
 */
export const ABILITIES = {
  knight: {
    id: "bulwark", name: "Bulwark Slam", glyph: "🛡",
    cd: 11, mana: 0,
    desc: "Slam the ground: damage and stun nearby foes, and raise a shield that halves incoming damage for a few seconds.",
  },
  barbarian: {
    id: "whirlwind", name: "Whirlwind", glyph: "🪓",
    cd: 12, mana: 0,
    desc: "Spin in a deadly arc, striking everything around you repeatedly for a short time.",
  },
  rogue: {
    id: "smoke", name: "Smoke Bomb", glyph: "💨",
    cd: 12, mana: 0,
    desc: "Vanish in a cloud of smoke — briefly untouchable and fleet-footed, while foes caught in the smoke are slowed.",
  },
  ranger: {
    id: "turret", name: "Sentry Turret", glyph: "🏹",
    cd: 16, mana: 0,
    desc: "Deploy an automated sentry that looses arrows at nearby foes for several seconds.",
  },
  mage: {
    id: "nova", name: "Arcane Nova", glyph: "🔮",
    cd: 8, mana: 30,
    desc: "Detonate a ring of arcane force, blasting and scorching everything around you.",
  },
};

export function abilityFor(classId) { return ABILITIES[classId] || ABILITIES.knight; }
